/* eslint-disable max-len */
/* eslint-disable camelcase */

const {
  object, string, array, date, number,
} = require('yup');

const attachment = object().shape({
  link: string().required(),
  name: string().required(),
  upload_url: string().required(),
  s3_file_path: string().required(),
  uploaded_date: string().required(),
});

const eprDetails = object().shape({
  subcategory_3: string().required('Subcategory 3 is required'),
  description: string().notRequired(),

  location_code: string().required('Location Code is required. Please make sure  you selected the proper option in the dropdown.'),
  location_desc: string().required('Location is required'),

  product_code: string().required('Product Code is required. Please make sure  you selected the proper option in the dropdown.'),
  product_desc: string().required('Product is required'),

  net_amount: number()
    .required('Net Amount is required')
    .min(-4000000000, 'Please enter the proper net amount')
    .max(4000000000, 'A maximum of 4,000,000,000.00 for a Net Amount is currently set.'),

  project_code: string().required('Project Code is required in the details. Please make sure you selected the proper option in the dropdown.'),
  project_desc: string().required('Project Description is required in the details. Please make sure you selected the proper option in the dropdown.'),

  charge_cost_center_code: string().required('Charge Cost Code is required in the details. Please make sure you selected the proper option in the dropdown.'),
  charge_cost_center_desc: string().required('Charge Cost Center Description is required in the details. Please make sure you selected the proper option in the dropdown.'),

  account_code: string().required('Account Code is required in the details. Please make sure  you selected the proper option in the dropdown.'),
  account_name: string().required('Account Name is required in the details. Please make sure  you selected the proper option in the dropdown.'),

  vat_input_code: string().required('VAT Input Code is required in the details. Please make sure  you selected the proper option in the dropdown.'),
  ewt_code: string().required('EWT Code is required in the details. Please make sure  you selected the proper option in the dropdown.'),
  opex_capex_code: string().required('OPEX/CAPEX is required'),
});

function validate(request) {
  const { billing_period_from, billing_period_to } = request;
  const eprObject = object().shape({
    company_code: string().required('Company Code is required. Please make sure  you selected the proper option in the dropdown.'),
    company_name: string().required('Company Name is required'),

    category: string().required('Category is required'),
    subcategory_1: string().required('Subcategory 1 is required'),
    subcategory_2: string().required('Subcategory 2 is required'),

    particulars: string().required('Particulars is required'),

    total_amount: (() => {
      if (request && request.currency && request.currency === 'USD') {
        return number()
          .required('Total Amount is required')
          .min(10, 'The total amount must be 10.00 USD and above');
      }
      return number()
        .required('Total Amount is required')
        .min(1000, 'The total amount must be 1,000.00 PHP and above');
    })(),

    accounting_processors: array()
      .of(string().email())
      .required('Accounting Processor/s are required. Please make sure you selected a Subcategory 2.'),

    attachment: array()
      .of(attachment)
      .required('Attachment is required')
      .min(1, 'At least one attachment is required'),

    payee_paygroup: string().notRequired(), // NOTE: not all payees are belonging to a payee group
    payee_code: string().required('Payee Code is required. Please make sure you selected the proper option in the dropdown.'),
    payee_desc: string().required('Payee is required.'),

    // NOTE: Moved the project information to the details section
    project_code: string().notRequired(),
    project_desc: string().notRequired(),

    // NOTE: Moved the project information to the details section
    cost_center_code: string().notRequired(),
    cost_center_desc: string().notRequired(),

    mode_of_payment: string().required('Mode of Payment is required'),
    ref_no: string().required('Reference No is required'),
    date_payable: date().required('Date Payable is required'),

    billing_period_from: date()
      .required('Billing Period From is required')
      .max(billing_period_to, 'Billing Period From cannot be later than Billing Period To'),

    billing_period_to: date()
      .required('Billing Period To is required')
      .min(billing_period_from, 'Billing Period To cannot be earlier that Billing Period From'),

    details: array()
      .of(eprDetails)
      .required('Line Items are required. Please add at least one line item.')
      .min(1, 'At least 1 transaction detail is required')
      .max(100, 'Only a maximum of 100 transaction detail entries are allowed.'),
  });

  return eprObject.validate(request);
}

export default validate;
